import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { useLayoutEffectIsomorphic } from '@chegg-ui/utils';
import { useWindowDimensions } from './useWindowDimensions';
export var useCalculatedOffset = function useCalculatedOffset(_ref) {
  var ref = _ref.ref,
      isOpen = _ref.isOpen,
      onboardingType = _ref.onboardingType;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      offsets = _useState2[0],
      setOffsets = _useState2[1];

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  var observer = useRef(new MutationObserver(
  /* istanbul ignore next */
  function (mutations) {
    return mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) calculateOffset();
    });
  }));

  if (ref.current && ref.current.parentElement && ref.current.parentElement.lastChild) {
    var lastChild = ref.current.parentElement.lastChild;
    observer.current.observe(lastChild, {
      childList: true
    });
  }

  useEffect(function () {
    return function () {
      return observer.current.disconnect();
    };
  });

  var calculateOffset = function calculateOffset() {
    /* istanbul ignore else */
    if (ref.current && ref.current.parentElement && ref.current.parentElement.lastChild) {
      var _lastChild = ref.current.parentElement.lastChild;

      var _ref$current$getBound = ref.current.getBoundingClientRect(),
          currentRight = _ref$current$getBound.right,
          currentWidth = _ref$current$getBound.width,
          bottom = _ref$current$getBound.bottom;

      var _lastChild$getBoundin = _lastChild.getBoundingClientRect(),
          lastChildRight = _lastChild$getBoundin.right;

      setOffsets({
        topOffset: bottom,
        modalOffset: lastChildRight - currentRight,
        pointerOffset: lastChildRight - currentRight + currentWidth / 2
      });
    }
  }; // all calculations are client-side only and rely on all other DOM modification being done


  useLayoutEffectIsomorphic(function () {
    calculateOffset();
  }, [width, isOpen, onboardingType]);
  return offsets;
};